import type { Permission } from '@/shared/constants';

import { usePermissionItems } from '../api';
import type { PermissionItem } from '../api/types';

export type UsePermissionItemResult = {
	item: PermissionItem | undefined;
	isLoading: boolean;
	isError: boolean;
};

export const usePermissionItem = (permission: Permission): UsePermissionItemResult => {
	const { data, isLoading, isError } = usePermissionItems();

	const item = data?.find((i) => i.permission === permission);

	return { item, isLoading, isError };
};
